import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { StudentPicker } from "@/components/StudentPicker";
import { toast } from "sonner";
import { Star } from "@phosphor-icons/react";

const PREDIKAT = ["Perlu Bimbingan", "Cukup", "Baik", "Sangat Baik"];

export default function InputPenilaian() {
  const [students, setStudents] = useState([]);
  const [sid, setSid] = useState(null);
  const [aspects, setAspects] = useState([]);
  const [scores, setScores] = useState({});
  const [predikat, setPredikat] = useState("Baik");
  const [note, setNote] = useState("");
  const period = `Semester 1 - ${new Date().getFullYear()}`;

  useEffect(() => {
    api.get("/students").then((r) => { setStudents(r.data); if (r.data[0]) setSid(r.data[0].id); });
    api.get("/assessment/aspects").then((r) => {
      setAspects(r.data);
      setScores(Object.fromEntries(r.data.map((a) => [a, 3])));
    });
  }, []);

  useEffect(() => {
    if (!sid) return;
    api.get(`/assessments?student_id=${sid}`).then((r) => {
      const a = r.data[0];
      if (a) {
        setPredikat(a.predikat);
        setNote(a.note || "");
        setScores(Object.fromEntries(a.aspects.map((x) => [x.name, x.stars])));
      }
    });
  }, [sid]);

  const save = async () => {
    if (!sid) return;
    try {
      await api.post("/assessments", {
        student_id: sid, period, predikat,
        aspects: aspects.map((a) => ({ name: a, stars: scores[a] || 3 })), note,
      });
      toast.success("Penilaian tersimpan");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div>
      <PageHeader title="Penilaian Perkembangan" />
      <div className="px-5 pt-4">
        <p className="text-xs text-stone-400 uppercase tracking-wide mb-2">Pilih Siswa</p>
        <StudentPicker students={students} value={sid} onChange={setSid} />

        <p className="text-xs text-stone-400 uppercase tracking-wide mb-2">Predikat</p>
        <div className="grid grid-cols-2 gap-2 mb-4">
          {PREDIKAT.map((p) => (
            <button key={p} data-testid={`predikat-${p}`} onClick={() => setPredikat(p)}
              className={`py-2.5 rounded-xl text-sm font-semibold transition-colors ${predikat === p ? "bg-primary text-white" : "bg-white border border-stone-200 text-stone-600"}`}>
              {p}
            </button>
          ))}
        </div>

        <p className="text-xs text-stone-400 uppercase tracking-wide mb-2">Aspek Perkembangan</p>
        <div className="bg-white rounded-3xl border border-stone-200/60 shadow-sm divide-y divide-stone-100 mb-4 overflow-hidden">
          {aspects.map((a) => (
            <div key={a} className="flex items-center justify-between px-4 py-3">
              <span className="text-stone-700 text-sm flex-1">{a}</span>
              <div className="flex gap-1" data-testid={`stars-${a}`}>
                {[1, 2, 3, 4, 5].map((n) => (
                  <button key={n} onClick={() => setScores({ ...scores, [a]: n })}>
                    <Star size={22} weight="fill" className={n <= (scores[a] || 0) ? "text-secondary" : "text-stone-200"} />
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-xs text-stone-400 uppercase tracking-wide mb-2">Catatan Guru</p>
        <textarea data-testid="note-input" value={note} onChange={(e) => setNote(e.target.value)} rows={3}
          placeholder="Catatan perkembangan anak..."
          className="w-full bg-white border border-stone-200 rounded-2xl py-3 px-4 mb-4 outline-none focus:border-primary resize-none" />

        <button data-testid="save-penilaian-btn" onClick={save} className="w-full bg-primary text-white font-semibold py-4 rounded-full active:scale-95 transition-transform">
          Simpan Penilaian
        </button>
      </div>
    </div>
  );
}
